import React from 'react';
import {useAppSelector} from "common/hook";


export const StatusTest = () => {
    const testData = useAppSelector(state => state.getTests.model)



    return (
        <div className="details-data-box three-cols">
            <div className="col">
                <p className="col-title">Статус</p>
                <p className={`status-item ${testData.published ? 'done' : 'not-done'}`}>
                    {testData.published ? 'Тест активен' : 'Тест не активен'}
                </p>

            </div>
            <div className="col">
                <p className="col-title">Автор</p>
                <p>{testData?.author?.name}</p>
            </div>
            <div className="col">
                <p className="col-title">Доступ</p>
                {testData.available === '0' ? (
                    <p>Выбранным студентам и/или группам</p>
                ) : (
                    <p>Доступно всем</p>
                )}
            </div>
        </div>
    )
};
